import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, Subscription } from 'rxjs';

import { AuthenticationService } from './authentication.service';
import { CredentialService } from './credential.service';

import {
  OA,
  SHEETS
} from '../../ngrx/category-types';

const errorCodes = [400, 401, 403, 404];

@Injectable()
export class ConfigService {

  constructor(private authService: AuthenticationService,
    private credentialService: CredentialService,
    private store: Store<any>
  ) { }

  private invokeTemplateLaserFlagMapping(payload: any): Observable<any> {
    return new Observable(observer => {

      this.credentialService.lambda.invoke({
        FunctionName: environment.magentoTemplateLaserFlagMapFunction,
        Payload: JSON.stringify(payload)
        }, (err, data) => {
          if (err) {
            if (errorCodes.find(code => code === err.statusCode) && localStorage.getItem('currentUser')) {
              this.authService.refreshCredentials();
            }
            observer.error(err);
          } else {
            const output = typeof data.Payload === 'string'
              ? JSON.parse(data.Payload)
              : data.Payload;
            observer.next(output);
          }
        });
    });
  }

  getTemplateLaserFlagMapping(templateCode: string): Observable<any> {
    return this.invokeTemplateLaserFlagMapping({ "pathParameters": {templateCode} });
  }

  private invokeMaterialLaserFlagMapping(payload: any): Observable<any> {
    return new Observable(observer => {

      this.credentialService.lambda.invoke({
        FunctionName: environment.magentoMaterialLaserFlagMapFunction,
        Payload: JSON.stringify(payload)
        }, (err, data) => {
          if (err) {
            if (errorCodes.find(code => code === err.statusCode) && localStorage.getItem('currentUser')) {
              this.authService.refreshCredentials();
            }
            observer.error(err);
          } else {
            const output = typeof data.Payload === 'string'
              ? JSON.parse(data.Payload)
              : data.Payload;
            observer.next(output);
          }
        });
    });
  }

  getMaterialLaserFlagMapping(materialCode: string): Observable<any> {
    return this.invokeMaterialLaserFlagMapping({ "pathParameters": {materialCode} });
  }

  private invokeUpdateMaterialTemplateLaserFlag(payload: any): Observable<any> {
    return new Observable(observer => {

      this.credentialService.lambda.invoke({
        FunctionName: environment.magentoUpdateLaserFlagFunction,
        Payload: JSON.stringify(payload)
        }, (err, data) => {
          if (err) {
            if (errorCodes.find(code => code === err.statusCode) && localStorage.getItem('currentUser')) {
              this.authService.refreshCredentials();
            }
            observer.error(err);
          } else {
            const output = typeof data.Payload === 'string'
              ? JSON.parse(data.Payload)
              : data.Payload;
            observer.next(output);
          }
        });
    });
  }

  updateMaterialTemplateLaserFlag(materialCode: string, templateCode: string, laserEnabledFlag: boolean): Observable<any> {
    return this.invokeUpdateMaterialTemplateLaserFlag({ 
        "body": {
            materialCode,
            templateCode, 
            laserEnabledFlag, 
        },
    });
  }
  
}


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/services/config.service.ts